/**
 * True once prefs have loaded SUCCESSFULLY — `state.loaded` alone also flips true on a
 * FAILED fetch (`userPreferences.ts`'s `rejected` case), leaving `preferences` empty.
 * Treating that as "loaded" would make the immutable-first-touch check in
 * `usePersistStartTracking` see `trackingAlreadyStored=false` and clobber an existing
 * snapshot the failed GET just couldn't confirm.
 *
 * Kept in its own zero-dependency file (no `@/store` import) so it's unit-testable
 * without pulling in the whole store chain, which touches `window.config` at module
 * scope (`src/api/endpoints.ts`) and can't load under jest's jsdom-less env.
 */
export const isPrefsReliablyLoaded = (s: { loaded: boolean; error: string | null | undefined }): boolean =>
  s.loaded && s.error == null;
